<template>
  <div class="cust-container">
    <menuBar></menuBar>
    <div>
      <div class="banner">
        <img src="@/assets/images/stem/banner.jpg" />
      </div>

      <div class="content" v-if="$i18n.locale === 'en'">
        <div class="title">Study STEM at SCAD</div>
        <div class="desc">
          <ul>
            <li>
              SCAD offers 30 STEM-designated undergraduate and graduate degree
              programs across fields including digital media, design,
              architecture, and technological innovation, empowering students to
              unite creative thinking with emerging technologies.
            </li>
            <li>
              SCAD’s future-minded curriculum incorporates professional-level
              technology and advanced learning resources, while internships,
              professional certifications, and real-world SCADpro assignments
              help students build meaningful industry experience.
            </li>
            <li>
              Career preparation is embedded throughout the SCAD experience. A
              2026 study found that 99% of recent SCAD graduates were employed,
              pursuing further education, or both within 12 months of
              graduation, supported by resources including personal career
              coaching, alumni programs, and SCADamp professional presentation
              studio.
            </li>
          </ul>
        </div>
        <div class="line" style=""></div>

        <div>
          <video
            style="width: 100%"
            src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260716/stem_%40_scad_impact_v13.mp4"
            controls
            poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260716/stem_%40_scad_impact_v13.mp4?x-oss-process=video/snapshot,t_4000"
          ></video>
        </div>

        <!--        <div class="title-list">-->
        <!--          <div class="title-row">-->
        <!--            <div>Advertising</div>-->
        <!--            <div>Architecture</div>-->
        <!--            <div>Design for sustainability</div>-->
        <!--            <div>Furniture design</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Animation</div>-->
        <!--            <div>Creative business leadership</div>-->
        <!--            <div>Design management</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Graphic design</div>-->
        <!--            <div>Industrial design</div>-->
        <!--            <div>Luxury and brand management</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Immersive reality</div>-->
        <!--            <div>Interactive design and game development</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Service design</div>-->
        <!--            <div>User experience (UX) design</div>-->
        <!--            <div>Visual effects</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>Service design</div>-->
        <!--            <div>User experience (UX) design</div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>

      <div class="content" v-if="$i18n.locale === 'zh'">
        <div class="title">在 SCAD 学习 STEM</div>
        <div class="desc">
          <ul>
            <li>
              SCAD目前开设30个STEM认证本科及研究生专业，涵盖数字媒体、设计、建筑及技术创新等多个领域，帮助学生将创意思维与前沿科技相结合。
            </li>
            <li>
              SCAD所面向未来发展的课程体系中，融合了专业级技术与先进学习资源。学生还可通过实习、专业认证，以及校企合作平台SCADpro的真实企业项目积累行业实践经验，曾与谷歌、NIKE耐克、NASA美国国家航空航天局、达美航空等行业伙伴开展合作，共同探索现实世界中的创新解决方案。
            </li>
            <li>
              职业发展贯穿SCAD教育的全过程。2026年调查显示，99%的SCAD应届毕业生在毕业后12个月内实现就业、继续深造，或二者兼有；学校也通过一对一职业辅导、校友发展项目及SCADamp
              演讲工坊等资源，为学生和校友提供持续支持。
            </li>
          </ul>
        </div>
        <div class="line" style=""></div>

        <div>
          <video
            style="width: 100%"
            src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260716/stem_%40_scad_impact_v13.mp4"
            controls
            poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20260716/stem_%40_scad_impact_v13.mp4?x-oss-process=video/snapshot,t_4000"
          ></video>
        </div>
        <!--        <div class="title-list">-->
        <!--          <div class="title-row">-->
        <!--            <div>广告</div>-->
        <!--            <div>建筑学</div>-->
        <!--            <div>可持续性设计</div>-->
        <!--            <div>家具设计</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>动画</div>-->
        <!--            <div>创意商业领导力</div>-->
        <!--            <div>设计管理</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>平面设计</div>-->
        <!--            <div>工业设计</div>-->
        <!--            <div>奢侈品与品牌管理</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>沉浸式现实</div>-->
        <!--            <div>互动设计与游戏开发</div>-->
        <!--          </div>-->
        <!--          <div class="title-row">-->
        <!--            <div>视觉效果</div>-->
        <!--            <div>服务设计</div>-->
        <!--            <div>用户体验（UX设计）</div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <goTop></goTop>
    <custFooter></custFooter>
  </div>
</template>

<script>
import menuBar from "../../components/menuBar/index.vue";
import custFooter from "@/components/footer/Footer";
export default {
  metaInfo: {
    title: "SCAD", // set a title
  },
  name: "WhyChooseSCAD",
  components: {
    menuBar,
    custFooter,
  },
  data: function () {
    return {
      showVideo: false,
    };
  },
};
</script>

<style lang="less" scoped>
@import url(Stem.less);
</style>
